module.exports = __webpack_public_path__ + "static/img/logo33.fe70390.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo33.png
// module id = oxQM
// module chunks = 1